export default "__VITE_ASSET__D1amJ9cH__"